import { getDB } from '../storage/db';
import { isExportBundle } from '../types/index';
import { list as listInventory } from './inventoryService';
import { list as listRefills } from './refillService';
import { list as listSaltLevels } from './saltLevelService';
export async function exportAll() {
    const [inventory, refills, saltLevels] = await Promise.all([
        listInventory(),
        listRefills(),
        listSaltLevels(),
    ]);
    return {
        schemaVersion: 1,
        exportedAt: new Date().toISOString(),
        inventory,
        refills,
        saltLevels,
    };
}
export async function importAll(payload, mode) {
    if (!isExportBundle(payload)) {
        throw new Error('Invalid import file: schema check failed');
    }
    const bundle = payload;
    const db = await getDB();
    if (mode === 'overwrite') {
        await db.clear('inventory');
        await db.clear('refills');
        await db.clear('saltLevels');
    }
    // Insert inventory first, then refills, then salt levels
    for (const item of bundle.inventory) {
        await db.put('inventory', item);
    }
    for (const event of bundle.refills) {
        // Bypass availability validation on import; we trust historical data
        await db.put('refills', event);
    }
    const saltLevels = bundle.saltLevels ?? [];
    for (const reading of saltLevels) {
        await db.put('saltLevels', reading);
    }
    return { inventoryCount: bundle.inventory.length, refillCount: bundle.refills.length, saltLevelCount: saltLevels.length };
}
